import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component } from 'vue-property-decorator';
import AbpBase from '@/lib/AbpBase';
import PageRequest from '@/store/entities/page-request';
import CreateUser from './create-user.vue';
import EditUser from './edit-user.vue';
import BindingWeChat from '@/views/setting/user/binding-weChat.vue';
import SelectMemberModal from '@/views/coupons/components/select-member-modal.vue';
var PageUserRequest = /** @class */ (function (_super) {
    __extends(PageUserRequest, _super);
    function PageUserRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isActive = null; //nullable
        return _this;
    }
    return PageUserRequest;
}(PageRequest));
var Users = /** @class */ (function (_super) {
    __extends(Users, _super);
    function Users() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // filters: Filter[] = [
        //     { Type: FieldType.String, Value: '', FieldName: 'Keyword', CompareType: CompareType.Contains },
        //     { Type: FieldType.DataRange, Value: '', FieldName: 'CreationTime', CompareType: CompareType.Contains },
        //     { Type: FieldType.Boolean, Value: null, FieldName: 'IsActive', CompareType: CompareType.Equal }
        // ]
        _this.pagerequest = new PageUserRequest();
        _this.creationTime = [];
        _this.createModalShow = false;
        _this.editModalShow = false;
        _this.showWeXinModal = false;
        _this.userMember = {
            userId: 0,
            memberId: 0
        };
        return _this;
    }
    Users.prototype.edit = function () {
        this.editModalShow = true;
    };
    Object.defineProperty(Users.prototype, "list", {
        get: function () {
            return this.$store.state.user.list;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Users.prototype, "loading", {
        get: function () {
            return this.$store.state.user.loading;
        },
        enumerable: true,
        configurable: true
    });
    Users.prototype.create = function () {
        this.$store.commit('user/edit', {});
        this.createModalShow = true;
    };
    Users.prototype.isActiveChange = function (val) {
        console.log(val);
        if (val === 'Actived') {
            // this.filters[3].Value = true;
            this.pagerequest.isActive = true;
        }
        else if (val === 'NoActive') {
            // this.filters[3].Value = false;
            this.pagerequest.isActive = false;
        }
        else {
            // this.filters[3].Value = null;
            this.pagerequest.isActive = null;
        }
    };
    Users.prototype.pageChange = function (page) {
        this.$store.commit('user/setCurrentPage', page);
        this.getpage();
    };
    Users.prototype.pagesizeChange = function (pagesize) {
        this.$store.commit('user/setPageSize', pagesize);
        this.getpage();
    };
    Users.prototype.getpage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // let where = Util.buildFilters(this.filters);
                        // let pagerequest = new PageRequest();
                        // pagerequest.maxResultCount = this.pageSize;
                        // pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
                        // pagerequest.where = where;
                        this.pagerequest.maxResultCount = this.pageSize;
                        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
                        //filters
                        if (this.creationTime.length > 0 && this.creationTime[0] != null && this.creationTime[0].toString() != '') {
                            // this.pagerequest.from = this.creationTime[0];
                            this.pagerequest.from = new Date(+this.creationTime[0] + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
                            // iview 时区问题
                        }
                        if (this.creationTime.length > 1 && this.creationTime[0] != null && this.creationTime[0].toString() != '') {
                            // this.pagerequest.to = this.creationTime[1];
                            this.pagerequest.to = new Date(+this.creationTime[1] + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
                        }
                        return [4 /*yield*/, this.$store.dispatch({
                                type: 'user/getAll',
                                data: this.pagerequest
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Users.prototype, "pageSize", {
        get: function () {
            return this.$store.state.user.pageSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "totalCount", {
        get: function () {
            return this.$store.state.user.totalCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "currentPage", {
        get: function () {
            return this.$store.state.user.currentPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "columns", {
        get: function () {
            var _this = this;
            var vm = this;
            return [
                {
                    title: this.L('UserName'),
                    key: 'userName',
                    render: function (h, params) {
                        var row = params.row;
                        var actions = [];
                        actions.push(h('a', {
                            on: {
                                click: function () {
                                    // vm.showActivityDetail(row);
                                    vm.$router.push({
                                        name: 'user-info',
                                        params: {
                                            id: row.id
                                        }
                                    });
                                }
                            }
                        }, row.userName));
                        return h('div', actions);
                    }
                },
                {
                    title: this.L('Name'),
                    key: 'name'
                }, {
                    title: this.L('IsActive'),
                    render: function (h, params) {
                        return h('span', params.row.isActive ? _this.L('Yes') : _this.L('No'));
                    }
                },
                {
                    title: this.L('CreationTime'),
                    key: 'creationTimeStr'
                    // render: (h: any, params: any) => {
                    //     return h('span', new Date(params.row.creationTime).toLocaleDateString());
                    // }
                },
                {
                    title: '关联会员uid',
                    key: 'memberId',
                    render: function (h, params) {
                        return h('span', params.row.userMemberId != 0 ? (params.row.memberId + 10000).toString() : '');
                    }
                },
                // {
                //     title: this.L('LastLoginTime'),
                //     render: (h: any, params: any) => {
                //         return h('span', new Date(params.row.lastLoginTime).toLocaleString());
                //     }
                // },
                {
                    title: this.L('Actions'),
                    key: 'Actions',
                    width: 200,
                    render: function (h, params) {
                        if (params.row.userName === 'admin') {
                            return;
                        }
                        var actions = [];
                        var row = params.row;
                        if (vm.hasPermission('Pages.Administration.Users.BindingWeChat')) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'default',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: function () {
                                        // this.$store.commit('user/edit', params.row);
                                        // this.edit();
                                        if (params.row.userMemberId > 0) {
                                            _this.deleteUserMember(params.row.userMemberId);
                                        }
                                        else {
                                            _this.userMember = {
                                                userId: 0,
                                                memberId: 0
                                            };
                                            _this.userMember.userId = params.row.id;
                                            _this.showWeXinModal = true;
                                        }
                                    }
                                }
                            }, params.row.userMemberId > 0 ? '解除绑定' : '绑定微信'));
                        }
                        if (vm.hasPermission('Pages.Administration.Users.Edit')) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'default',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: function () {
                                        _this.$store.commit('user/edit', params.row);
                                        _this.edit();
                                    }
                                }
                            }, _this.L('Edit')));
                            if (row.isActive) {
                                actions.push(h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: function () {
                                            vm.activeOrDisableUser(row);
                                        }
                                    }
                                }, '停用'));
                            }
                            else {
                                actions.push(h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: function () {
                                            vm.activeOrDisableUser(row);
                                        }
                                    }
                                }, '启用'));
                            }
                        }
                        // if (vm.hasPermission('Pages.Administration.Users.Delete')) {
                        //     actions.push(h('Button', {
                        //         props: {
                        //             type: 'error',
                        //             size: 'small'
                        //         },
                        //         on: {
                        //             click: async () => {
                        //                 this.$Modal.confirm({
                        //                     title: this.L('Tips'),
                        //                     content: this.L('DeleteUserConfirm'),
                        //                     okText: this.L('Yes'),
                        //                     cancelText: this.L('No'),
                        //                     onOk: async () => {
                        //
                        //                         await this.$store.dispatch({
                        //                             type: 'user/delete',
                        //                             data: params.row
                        //                         });
                        //                         await this.getpage();
                        //
                        //                     }
                        //                 });
                        //             }
                        //         }
                        //     }, this.L('Delete')));
                        // }
                        return h('div', actions);
                    }
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Users.prototype.addMember = function (data) {
        var _this = this;
        this.userMember.memberId = data.id;
        var vm = this;
        this.$Modal.confirm({
            title: this.L('Tips'),
            content: '确认绑定吗？',
            okText: this.L('Yes'),
            cancelText: this.L('No'),
            onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    abp.ajax.post('/api/services/app/Member/SaveUserMember', vm.userMember).then(function () {
                        _this.showWeXinModal = false;
                        _this.getpage();
                    }).finally(function () {
                    });
                    return [2 /*return*/];
                });
            }); }
        });
        //
    };
    Users.prototype.activeOrDisableUser = function (row) {
        var _this = this;
        var str = '';
        if (row.isActive) {
            str = '确认停用该用户！';
        }
        else {
            str = '确认启用该用户！';
        }
        var vm = this;
        this.$Modal.confirm({
            title: this.L('Tips'),
            content: str,
            okText: this.L('Yes'),
            cancelText: this.L('No'),
            onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (row.isActive) {
                        vm.disableUser(row);
                    }
                    else {
                        vm.activeUser(row);
                    }
                    return [2 /*return*/];
                });
            }); }
        });
    };
    Users.prototype.activeUser = function (row) {
        var _this = this;
        this.$store.dispatch({
            type: 'user/activeUser',
            id: row.id
        }).then(function () {
            _this.$Notice.success({
                duration: 3,
                title: '操作成功'
            });
            _this.getpage();
        });
    };
    Users.prototype.disableUser = function (row) {
        var _this = this;
        this.$store.dispatch({
            type: 'user/disableUser',
            id: row.id
        }).then(function () {
            _this.$Notice.success({
                duration: 3,
                title: '操作成功'
            });
            _this.getpage();
        });
    };
    Users.prototype.deleteUserMember = function (id) {
        var _this = this;
        var vm = this;
        this.$Modal.confirm({
            title: this.L('Tips'),
            content: '确认解除绑定吗？',
            okText: this.L('Yes'),
            cancelText: this.L('No'),
            onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    abp.ajax.delete('/api/services/app/Member/DeleteUserMember?id=' + id).then(function () {
                        _this.getpage();
                    }).finally(function () {
                    });
                    return [2 /*return*/];
                });
            }); }
        });
    };
    Users.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.getpage();
                return [2 /*return*/];
            });
        });
    };
    Users = __decorate([
        Component({
            components: {
                SelectMemberModal: SelectMemberModal,
                BindingWeChat: BindingWeChat,
                CreateUser: CreateUser,
                EditUser: EditUser
            }
        })
    ], Users);
    return Users;
}(AbpBase));
export default Users;
